module.exports = __webpack_public_path__ + "static/bird-1a8f12218bc59e5cf50b6b29efb1aac0.jpg";